import ApplicationController from './application'

export default class extends ApplicationController {

  static targets = ['panel']

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  show() {
    this.panelTarget.classList.remove('invisible', 'opacity-0')
    document.addEventListener('click', this.handleOutsideClick)
  }

  hide() {
    this.panelTarget.classList.add('invisible', 'opacity-0')
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.contains('invisible') ? this.show() : this.hide()
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

}
